import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana46Div7M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1443_2589)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M635.135 709.47L686.461 755.247L723.915 678.952L690.622 647.047L635.135 709.47Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M592.137 669.239L635.14 709.467L690.627 647.044L649.011 608.203L592.137 669.239Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M550.517 631.784L592.132 669.238L649.006 608.202L606.004 569.361L550.517 631.784Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M507.511 591.557L550.513 631.786L606.001 569.362L562.998 530.521L507.511 591.557Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M463.127 552.718L507.517 591.559L563.004 530.523L518.614 491.682L463.127 552.718Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M420.122 501.39C432.606 523.585 445.091 537.456 463.124 552.715L518.611 491.679L495.029 457L420.122 501.39Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M390.992 455.615L420.123 501.392L495.031 457.002L467.287 409.838L390.992 455.615Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M363.249 407.064L390.992 455.615L467.287 409.838L439.544 361.287L363.249 407.064Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M336.889 358.511L363.245 407.062L439.54 361.285L411.797 314.121L336.889 358.511Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M309.149 311.349L336.893 358.513L411.8 314.123L385.444 266.959L309.149 311.349Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M281.403 265.57L309.147 311.347L385.442 266.958L356.311 218.406L281.403 265.57Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1443_2589" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1443_2589" transform="matrix(0.00190275 0 0 0.00252253 -3.797 -2.91734)"/>
    </pattern>
    <image id="image0_1443_2589" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};